import Button from 'components/shared/Box'
import Section from 'components/shared/Section'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const FamilySection = styled(Section)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    padding: 24px 16px;
    border-radius: 6px;

    @media ${respondAbove.xl} {
        width: 870px;
        padding: 56px 80px;
        border-radius: 8px;
    }
`

export const FamilyButton = styled(Button)`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 0;
    cursor: pointer;
    gap: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary_500};

    @media ${respondAbove.xl} {
        font-size: 16px;
        gap: 12px;
    }

    &:focus-visible,
    &:hover {
        color: ${({ theme }) => theme.colors.secondary_700};
    }
`
